module.exports = __webpack_public_path__ + "img/9.5999d79b.jpg";